import React from 'react'

import { Box } from 'ui/components/Box'
import {
    Dropdown,
    DropdownButton,
    DropdownContent,
    DropdownHeadSearch,
    DropdownItem,
    DropdownSeparator,
    DropdownSub,
    DropdownSubContent,
    DropdownSubTrigger,
    DropdownTitle,
} from 'ui/components/Dropdown'

import { useManageDataAddOrImportDropdownState } from './hooks/useManageDataAddOrImportDropdownState'

type ManageDataAddOrImportDropdownProps = {
    onSelectObject: (objectId: string) => void
    onOpenImportCsvModal: () => void
    onOpenImportTableDataModal: () => void
}

const ManageDataAddOrImportDropdownInner: React.FC<ManageDataAddOrImportDropdownProps> = ({
    onSelectObject,
    onOpenImportCsvModal,
    onOpenImportTableDataModal,
}) => {
    const {
        dataSyncIntegrations,
        sharedObjects,
        onAddTable,
        onIntegrationSelect,
        onSharedTableSelect,
    } = useManageDataAddOrImportDropdownState({ onSelectObject })

    return (
        <Dropdown modal={false}>
            <DropdownButton startIcon={{ name: 'Plus' }} size="s" variant="ghost">
                Add or import
            </DropdownButton>
            <DropdownContent
                style={{
                    width: '326px',
                }}
            >
                <DropdownItem
                    label="Add new table"
                    onClick={onAddTable}
                    startIcon={{ name: 'Plus' }}
                    variant="action"
                />
                <DropdownSeparator />
                <DropdownItem
                    label="Import from .CSV"
                    onClick={onOpenImportCsvModal}
                    startIcon={{ name: 'Import' }}
                />
                <DropdownItem
                    label="Paste data from spreadsheet"
                    onClick={onOpenImportTableDataModal}
                    startIcon={{ name: 'Table' }}
                />

                {!!dataSyncIntegrations.length && (
                    <>
                        <DropdownSeparator />
                        <DropdownTitle>Sync from</DropdownTitle>
                        {dataSyncIntegrations.map((integration) => (
                            <DropdownItem
                                key={integration.id}
                                onSelect={() => onIntegrationSelect(integration)}
                                leftSlotContent={() => (
                                    <Box
                                        as="img"
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                        }}
                                        src={integration.image_url}
                                        alt={integration.name}
                                        noShrink
                                    />
                                )}
                                label={integration.name}
                            />
                        ))}
                    </>
                )}

                {sharedObjects?.length > 0 && (
                    <DropdownSub>
                        <DropdownSeparator />
                        <DropdownSubTrigger
                            label="Add table from Workspace"
                            startIcon={{ name: 'Share2' }}
                        />
                        <DropdownSubContent head={<DropdownHeadSearch />}>
                            {sharedObjects.map((workspaceObject) => (
                                <DropdownItem
                                    key={workspaceObject._sid}
                                    label={workspaceObject.name}
                                    onSelect={() => onSharedTableSelect(workspaceObject)}
                                />
                            ))}
                        </DropdownSubContent>
                    </DropdownSub>
                )}
            </DropdownContent>
        </Dropdown>
    )
}

export const ManageDataAddOrImportDropdown = React.memo(ManageDataAddOrImportDropdownInner)
